<template>
  <div class="field is-flex is-justify-content-space-between is-align-items-center" :class="fieldStyle">
    <div>
      <label class="label m-0"><p>{{ title }} <slot name="title-addition"></slot> </p></label>
    </div>
    <div class="control">
      <label class="radio" v-for="option in question.options" :key="option.id">
        <input type="radio" name="answer" :value="option.id" v-on:input="handleAnswer" hidden />
        <p class="button m-0" :class="selectedClass(option)">{{ capitalizeFirstLetter(option.text) }}</p>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'QuestionYesNo',
  props: {
    question: {
      default: () => {},
      type: Object
    },
    title: {
      type: String,
      default: ''
    },
    fieldStyle: {
      type: String,
      default: ''
    },
    initValue: {
      type: String
    }
  },
  data () {
    return {
      answer: undefined
    }
  },
  created () {
    this.answer = this.initValue
  },
  methods: {
    selectedClass (option) {
      let className = ''
      if (this.answer == option.id) {
        switch (option.text) {
          case 'FALSE':
            className = 'is-danger'
            break
          case 'false':
            className = 'is-danger'
            break
          default:
            className = 'is-success'
        }
      }
      return className
    },
    handleAnswer (e) {
      const value = e.target.value
      this.answer = value
      this.$emit('input', { ...this.question, answer: value })
    },
    capitalizeFirstLetter (string) {
      const s = string.toLowerCase()
      return s[0].toUpperCase() + s.slice(1)
    }
  }
}
</script>
